export const parseToken = () => {
  try {
    const token = localStorage.getItem('user')
    if (!token) {
      return false
    }
    const parsed = JSON.parse(token).tokens.accessToken
    if (parsed) {
      return true
    }
    return false
  } catch (error) {
    localStorage.removeItem('token')
    return false
  }
}
export const parseUserLocalstorage = () => {
  try {
    const token = localStorage.getItem('user')
    if (!token) {
      return false
    }
    const parsed = JSON.parse(token)
    if (parsed.tokens) {
      return parsed.tokens
    }
    return false
  } catch (error) {
    localStorage.removeItem('token')
    return false
  }
}

export const isObjectEmpty = (obj: any): boolean => {
  if (obj == null || typeof obj !== 'object' || Array.isArray(obj)) {
    throw new Error('Input is not an object or is null/undefined/array')
  }

  return Object.keys(obj).length === 0
}
